import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./trainers.css";
import trainerImg from "../../assets/testingimages/otherimages/ourtraining.jpg";

function Trainers() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="trainers-section">
      <div className="container">

        <section>
          <div className="headlines-for-all" data-aos="fade-up">
            <h4>
              <span>Our </span> Trainers
            </h4>
          </div>
        </section>

        <div className="trainers-content">

          {/* Left text area */}
          <div className="trainers-text">
            <p data-aos="fade-up" data-aos-delay="100">
              At{" "}
              <strong>
                <span className="fazo-fazo"> Fazo Academy </span>
              </strong>
              , we are committed to delivering a{" "}
              <strong>
                comprehensive blend of theoretical knowledge and practical skills
              </strong>{" "}
              in Data Analysis through our expertise in{" "}
              <strong>industry-focused training</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="200">
              Our <strong>experienced Data Analysis instructors</strong> specialize in{" "}
              <strong>data cleaning, statistical analysis, and business insights</strong>{" "}
              techniques, ensuring students develop{" "}
              <strong>real-world data analysis expertise</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="300">
              Students gain hands-on experience with{" "}
              <strong>various data analysis tools and technologies</strong>, including{" "}
              <strong>
                Excel, SQL, Python, Pandas, NumPy, Power BI, and Tableau.
              </strong>
            </p>

            <p data-aos="fade-up" data-aos-delay="400">
              Our <strong>specialized training programs</strong> cover industry-leading
              tools and platforms like{" "}
              <strong>
                Advanced Excel, Pivot Tables, Data Visualization tools, Python libraries,
                and BI dashboards
              </strong>
              , enabling students to become proficient in{" "}
              <strong>data-driven decision making and reporting</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="500">
              Our <strong>dedicated Data Analysis trainer</strong> designs personalized
              training modules that include{" "}
              <strong>
                real-time datasets, business case studies, dashboard creation, reporting,
                and interview preparation
              </strong>{" "}
              through hands-on practical sessions.
            </p>
          </div>
          {/* Right image */}
          <div className="trainers-image">
            <img
              src={trainerImg}
              alt="Trainers"
              data-aos="zoom-in"
              data-aos-delay="300"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Trainers;
